import React, { useState, useEffect } from "react"
import { getDettaglioPagamenti } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import * as Constants from '../../utils/constants'
import {
  Container,
  Row,
  Col,
  Button,
  Alert
} from 'design-react-kit';

export const SibaMostraDettagliPagamento = ({ schedaPagamento, veicolo, handleSubmit, handleBack, handleDataLoaded }) => {

  const [dettaglioPagamenti, setDettaglioPagamenti] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      let annoDiImposta = Number(schedaPagamento.anno) +1;
      if(schedaPagamento.scadenza !== undefined && schedaPagamento.scadenza.includes('/')){
        let datiScadenza = schedaPagamento.scadenza.split('/');
        if(datiScadenza.length === 2) {
          annoDiImposta = Number(datiScadenza[1]);
        }
      }
      const responseDettaglioPagamenti = await getDettaglioPagamenti(annoDiImposta, veicolo.idVeicolo);
      console.log("responseDettaglioPagamenti=", responseDettaglioPagamenti);
      if (responseDettaglioPagamenti === undefined) {
        console.log('Pagamento %s per veicolo %s non trovato', annoDiImposta, veicolo.idVeicolo)
        setDettaglioPagamenti([])
        setLoading(false)
        return
      }
      setDettaglioPagamenti(responseDettaglioPagamenti)
      handleDataLoaded(responseDettaglioPagamenti)
      setLoading(false)
    }
    fetchData();
  }, []);

  useEffect(() => {
    moveFocusTo("chiudi_dettaglio");
  })

  const drawTableHeader = (numeroProgressivo) => {
    return numeroProgressivo === 0 ? React.Fragment : (
      <thead>
        <tr>
          <th>Pagamento </th>
          <th>#{numeroProgressivo}</th>
        </tr>
      </thead>
    )
  }

  const drawSeparator = () => {
    return <><br /><hr /></>;
  }

  const drawTable = (dettaglioPagamento, numeroProgressivo) => {
    console.log("dettagliPagamento => numeroProgressivo=", numeroProgressivo)
    return (
      <Container className="px-2 my-2" id="dettagli" tag="section">
        {drawSeparator()}
        <table className="table table-striped table-sm" id="vertical-1">
          {drawTableHeader(numeroProgressivo)}
          <tbody>
            <tr>
              <th>Targa</th>
              <td>{dettaglioPagamento.targa}</td>
            </tr>
            <tr>
              <th>Tipo</th>
              <td>{dettaglioPagamento.tipoVeicolo.descrizione}</td>
            </tr>
            {/*<tr>
              <th>Intermediario</th>
              <td>{dettaglioPagamento.tipoIntermediario.descrizione}</td>
            </tr>*/}
            <tr>
              <th>Data</th>
              <td>{dettaglioPagamento.dataPagamentoEffettuato}</td>
            </tr>
            <tr>
              <th>Scadenza</th>
              <td>{dettaglioPagamento.dataScadenza.mese.descrizione}-{dettaglioPagamento.dataScadenza.anno}</td>
            </tr>
            <tr>
              <th>Validità</th>
              <td>{dettaglioPagamento.validita}</td>
            </tr>
            <tr>
              <th>Ricevuta</th>
              <td>{dettaglioPagamento.numeroRicevuta}</td>
            </tr>
            <tr>
              <th>Importo totale</th>
              <td><strong>{dettaglioPagamento.importo.totale.importo.toFixed(2)}</strong> {dettaglioPagamento.importo.totale.divisa.descrizione}</td>
            </tr>
          </tbody>
        </table>
      </Container>
    )
  }

  // *** modifiche button x STALIGK-821 ***

  const drawOnlyButtonRimborsa = () => {
    if (dettaglioPagamenti.length > 0) {
      return (
      <Row>
        <Col md={4} />
        <Col md={4}>
        <Button
          //* STALIGK-821 className="btn btn-warning"
          className="btn btn-primary btn-rimborsi"
          size="xs"
          color="primary"
          icon={false}
          tag="button"
          onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.RIM_CHOICE_PAGAMENTO_RIMBORSA })}
        > Chiedi rimborso
        </Button>
       </Col>
       <Col md={4} />
      </Row> 
      )
    } else {
      return <><br />Nessun pagamento trovato per l'anno {schedaPagamento.anno}<br /></>
    }
  }
  
  const drawButtonRimborsa = () => {
      return (
        <Col xl={3} lg={4} md={5}>
        <Button
          //* STALIGK-821 className="btn btn-warning"
          className="btn btn-primary btn-rimborsi"
          size="sm"
          color="primary"
          icon={false}
          tag="button"
          onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.RIM_CHOICE_PAGAMENTO_RIMBORSA })}
        > Chiedi rimborso
        </Button>
       </Col> 
      )
  }

  const drawButtonAllineaAndRimborsa = () => {
    return (
     <Row>
      <Col xl={3} lg={2} md={1}/>
      <Col xl={3} lg={4} md={5}>
        <Button
          //* STALIGK-821	className="btn btn-warning"
          className="btn btn-primary btn-rimborsi"
          size="sm"
          color="primary"
          icon={false}
          tag="button"
          onClick={() => handleSubmit({ schedaPagamento: schedaPagamento, choice: Constants.RIM_CHOICE_PAGAMENTO_ALLINEA })}
        > Chiedi correzione scadenza
        </Button>
      </Col>
      {drawButtonRimborsa()}
      <Col xl={3} lg={2} md={1}/>
     </Row>
    )
  }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="dettagliDati" tag="section">
      <Row>
        <Col>
          <h3>Dettagli Pagamento</h3>
          <br />
          {dettaglioPagamenti.length > 1 ? <Alert color="warning" > Sono presenti più pagamenti è possibile richiedere lo spostamento su una scadenza successiva oppure il rimborso.<br/>Attenzione: per la correzione scadenza è previsto il rimborso di sanzioni ed interessi per somme superiori a 16 euro.</Alert> : React.Fragment}

          {dettaglioPagamenti.length === 1 ? (drawTable(dettaglioPagamenti[0], 0))
            : (
              dettaglioPagamenti.map((dettagliPagamento, i) => (drawTable(dettagliPagamento, ++i)))
            )
          }
        </Col>
      </Row>
         {dettaglioPagamenti.length > 1 ? drawButtonAllineaAndRimborsa() : drawOnlyButtonRimborsa()}
     <Row>
        <Col />
        <Col>
          <div style={{ padding: "10px" }}>
            <Button id="chiudi_dettaglio" className="btn btn-primary" size="xs" color="primary" icon={false} tag="button" onClick={handleBack} >
              Torna indietro
            </Button>
          </div>
        </Col>
        <Col />
      </Row>
    </Container>
  )
}

export default SibaMostraDettagliPagamento;